document.addEventListener('DOMContentLoaded', () => {
	const sections = document.querySelectorAll('.orla-process');

	// small random offset for hand drawn feel
	function jitter(value, amount = 6) {
		return value + (Math.random() - 0.5) * amount;
	}

	function buildPath(section) {
		const svg = section.querySelector('.orla-process-path');
		const path = svg.querySelector('path');
		const dots = section.querySelectorAll('.orla-process-dot');

		if (!dots.length) return;

		const sectionRect = section.getBoundingClientRect();
		let d = '';

		dots.forEach((dot, i) => {
			const dotRect = dot.getBoundingClientRect();

			const x = jitter(dotRect.left + dotRect.width / 2 - sectionRect.left);
			const y = jitter(dotRect.top + dotRect.height / 2 - sectionRect.top);

			if (i === 0) {
				const startY = y - section.offsetHeight;

				d += `M ${x} ${startY} L ${x} ${y}`;
			} else {
				const prevRect = dots[i - 1].getBoundingClientRect();

				const px = jitter(
					prevRect.left + prevRect.width / 2 - sectionRect.left
				);
				const py = jitter(
					prevRect.top + prevRect.height / 2 - sectionRect.top
				);

				const cx = jitter((px + x) / 2);
				const cy = jitter((py + y) / 2);

				d += ` Q ${cx} ${cy} ${x} ${y}`;
			}
		});

		path.setAttribute('d', d);

		const length = path.getTotalLength();

		path.style.strokeDasharray = length;
		path.style.strokeDashoffset = length;

		return { path, length };
	}

	sections.forEach((section) => {
		requestAnimationFrame(() => {
			const result = buildPath(section);
			if (!result) return;

			const { path, length } = result;

			const steps = section.querySelectorAll('.orla-process-step');

			let maxProgress = 0;

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							entry.target.classList.add('visible');

							const index = [...steps].indexOf(entry.target);
							const progress = (index + 1) / steps.length;

							// only increase progress
							if (progress > maxProgress) {
								maxProgress = progress;
								path.style.strokeDashoffset =
									length * (1 - maxProgress);
							}
						}
					});
				},
				{
					threshold: 0.4,
				}
			);

			steps.forEach((step) => observer.observe(step));
		});
	});

	window.addEventListener('resize', () => {
		sections.forEach((section) => {
			buildPath(section);
		});
	});
});
